import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Divider,
  Grid,
  Hidden,
  Typography,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";

import AchievementItem from "./AchievemntItem";
import CarouselBtn from "../../components/Common/Buttons/CarouselBtn";
import TitleContainer from "./TitleContainer";
import UseMobile from "../../hooks/useIsMobile";
import LayoutContainer from "../../components/LayoutsContainer";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f1f1f1",
    width: "100%",
    height: "auto",
    marginTop: "5vh",
    paddingTop: "3vh ",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      height: "auto",
      margin: "0vh 0vw",
      padding: "2vh 0vw",
    },
  },
  mobileImage: {
    width: "100%",
    objectFit: "contain",
  },
  adContainer: {
    paddingTop: theme.spacing(2),
  },
}));

const Advertisement = ({ data }) => {
  const classes = useStyles();
  const isMobile = UseMobile();
  console.log("data", data);
  return (
    <>
      <div className={classes.root}>
        <LayoutContainer>
          <Grid container>
            <Grid item className={classes.titleContainer}>
              <TitleContainer title={data?.title} />
            </Grid>
            <Grid item className={classes.adContainer}>
              <img src={data.mobileImageSrc} className={classes.mobileImage} />
            </Grid>
          </Grid>
        </LayoutContainer>
      </div>
    </>
  );
};
export default Advertisement;
